import { isType } from 'variant';
import {
  deleteAuthData,
  readAccountAuthData,
  AccountAuthData,
} from './auth-data.js';
import { client } from './client.js';

export async function logout() {
  const authData = await readAccountAuthData();
  if (!isType(authData, AccountAuthData.Unauthenticated)) {
    await client.revokeRefreshToken(
      { token: authData.refreshToken },
      authData.userInfo
    );
  }

  await deleteAuthData();

  return null;
}
